import ForgotPasswordComponent from "../../components/auth/forgot-password"

const ForgotPassword = () => {
  return (
    <div>
        <ForgotPasswordComponent/>
    </div>
  )
}

export default ForgotPassword